let ip;
let basePath;
let basePathCantant;
let apiVersion = "v1";

if (process.env.REACT_APP_API_URL === 'localhost') {
    // console.log('cucu',process.env.REACT_APP_API_URL)
    ip = process.env.REACT_APP_API_URL;
    basePath = `http://${ip}:3977/api`;
    basePathCantant = `http://${ip}:3001/api/v1/process-data`;
}else{
    //==============================================================
    ip = 'restapi.capillarit.eu';
    basePath = `https://${ip}:3977/api`;
    basePathCantant = `https://${ip}:3001/api/v1/process-data`;
    //==============================================================
    // ip = 'restapi-test.capillarit.eu';
    // basePath = `https://${ip}:3977/api`;
    // basePathCantant = `https://${ip}:3001/api/v1/process-data`;
}

export {
    ip,
    basePath,
    apiVersion,
    basePathCantant
};

// export let ip = process.env.REACT_APP_API_URL;
// export const basePath = `http://${ip}:3977/api`;
// export const apiVersion = "v1";
// export const basePathCantant = `http://${ip}:3001/api/v1/process-data`;


// export const ip = "restapi.capillarit.com";
// export const basePath = `https://${ip}:3977/api`;
// export const apiVersion = "v1";
// export const basePathCantant = `https://${ip}:3001/api/v1/process-data`;